import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import './Login.css';

const Login = () => {
  const { user, login } = useAuth();
  const { tenantConfig } = useTenant();
  const navigate = useNavigate();
  const params = useParams();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const credentials = {
      username: formData.get('username'),
      password: formData.get('password')
    };

    try {
      setLoading(true);
      setError('');
      console.log('Attempting login...');
      await login(credentials);
    } catch (error) {
      console.error('Login error:', error);
      // Provide detailed error message from server or fallback
      const errorMessage = error.response?.data?.message 
        || error.message 
        || 'Login failed. Please check your credentials and try again.';
      setError(errorMessage);
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('shipEngineAPI');
    } finally {
      setLoading(false);
    }
  };

  // Redirect if already authenticated
  useEffect(() => {
    if (user) {
      const tenantPrefix = params.tenantPrefix;
      if (tenantPrefix) {
        navigate(`/${tenantPrefix}/inventory`);
      } else {
        navigate('/inventory');
      }
    }
  }, [user, navigate, params.tenantPrefix]);

  return (
    <div className="login-wrapper">
      <main className="login-content">
        <div 
          className="login-page-header" 
          style={{ 
            backgroundImage: "url('/splash.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="login-container">
            <div className="login-row">
              <div className="login-col">
                <div className="login-card login-fadeIn">
                  <div className="login-card-header">
                    <div className="login-gradient-primary">
                      <img 
                        src={tenantConfig.loginLogo} 
                        className="img-fluid px-3" 
                        alt="logo"
                        onError={(e) => {
                          e.target.src = '/bannernew.png'; // Fallback to default logo
                        }}
                      />
                      <h4 className="login-text-white login-text-center">
                        {/*{tenantConfig.tenantName}*/}
                      </h4>
                      <h4 className="login-text-white login-text-center">
                        Sign in
                      </h4>
                    </div>
                  </div>

                  <div className="login-card-body">
                    <form onSubmit={handleSubmit} className="login-text-center">
                      <div className="login-input-group">
                        <input
                          type="text"
                          name="username"
                          className="form-control"
                          placeholder="Username"
                          required
                        />
                      </div>

                      <div className="login-input-group">
                        <input
                          type="password"
                          name="password"
                          className="form-control"
                          placeholder="Password"
                          required
                        />
                      </div>

                      {error && (
                        <div className="login-error-message">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
                          </svg>
                          <span>{error}</span>
                        </div>
                      )}

                      <div className="login-text-center">
                        <button
                          type="submit"
                          className="login-btn"
                          disabled={loading}
                        >
                          {loading ? 'Signing in...' : 'Sign in'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Login;
